export const LOCATION_TYPE_KEY = 'tipoUbicacionId';
export const ACTIVE_KEY = 'active';
export const POSITION_KEY = 'position';
export const OPTION_PARTES = [
  {
    id: 1,
    value: true,
    label: 'Todos',
    variant: 'primary'
  },
  {
    id: 2,
    value: false,
    label: 'Partes Notificados',
    variant: 'primary'
  }
];

export const SORT_OPTIONS = [
  { id: 1, nombre: 'Ubicación', value: 'location', label: 'Ubicación' },
  { id: 2, nombre: 'Proveedor', value: 'provider', label: 'Proveedor' }
];
export const getInspectorFilters = 1;
export const getAprooverFilters = 2;

export const providerSort = 'provider';
export const locationSort = 'location';

export const tooltipLabels = {
  idsProveedores: 'Proveedor: ',
  contratosIds: 'Contrato: ',
  estadoParteId: 'Estado: ',
  idsEquipos: 'Equipo: ',
  idsEventos: 'Evento: ',
  partesVisualizar: 'Partes a visualizar: ',
  serviciosIds: 'Servicio: ',
  ubicacionesIds: 'Ubicación: ',
  tipoUbicacionId: 'Tipo Ubicacion: ',
  fechaDesde: 'Fecha Desde: ',
  fechaHasta: 'Fecha Hasta: ',
  posicionesLineas: 'Pos-Linea: '
};
